export default __webpack_public_path__ + "static/media/wxpay.74fe6991.png";